import { useState } from 'react'
import { HeadLine } from '../../layouts/headers/HeadLine'
import './Style.css'
import { useRequest } from '../../hooks/useRequest';
import { getApiUrl } from '../../app-config';
import { HotelInformationList } from './HotelInformationList';
import { useSelector } from 'react-redux';
import Text from '../../components/native/Text';

export const MainSection = () => {

    const hotel = useSelector((store: any) => (store.app));
    const uiData = useSelector((store: any) => (store.ui));
    const { data } = useRequest(getApiUrl(`Hotel/${hotel.id}/Information`));
    const [tab, setTab] = useState(0);

    const handleTab: Function = (n: number) => {
        setTab(n);
    }

    if (!data) {

        return (<h1>Cargando...</h1>);
    }

    return (
        <>
            <div className="w-full absolute z-1 head-hi" style={{ background: uiData.btnPrimaryColor }}>
                <HeadLine title='Información del hotel' backurl='/' />

                <div className='w-full overflow-x-auto'>
                    <div className='flex justify-between items-center pl-6 pr-6 tab-navigator-h1 gap-4'>

                        {
                            data?.map((item, index) => {
                                return (
                                    <div key={'sect' + (index + 1)} className={'flex flex-col items-center justify-bewteen pb-4 ' + (tab === index && 'is-selected')} onClick={() => { handleTab(index) }}>
                                        <img src="assets/img/svg/hotel_icon.svg" alt="hotel icon" width={'24px'} height={'24px'} />

                                        <span className='mt-4 section-txt-hi text-center'><Text>{item.title}</Text></span>

                                    </div>
                                )
                            })
                        }

                        {/*  <div className={'flex flex-col items-center justify-bewteen pb-4 ' + (tab === 0 && 'is-selected')} onClick={() => { handleTab(0) }}>
                            <img src="assets/img/svg/hotel_icon.svg" alt="hotel icon" width={'24px'} height={'24px'} />

                            <span className='mt-4 section-txt-hi text-center'>Bienvenida</span>

                        </div> */}

                        {/* 
                        <div className={'flex flex-col items-center justify-bewteen pb-4 ' + (tab === 1 && 'is-selected')} onClick={() => { handleTab(1) }}>
                            <img src="assets/img/svg/hotel_icon.svg" alt="hotel icon" width={'24px'} height={'24px'} />

                            <span className='mt-4 section-txt-hi text-center'>Política  <br /> del Hotel</span>

                        </div>

                        <div className={'flex flex-col items-center justify-bewteen pb-4 ' + (tab === 2 && 'is-selected')} onClick={() => { handleTab(2) }}>
                            <img src="assets/img/svg/hotel_icon.svg" alt="hotel icon" width={'24px'} height={'24px'} />

                            <span className='mt-4 section-txt-hi text-center'>Clean <br />
                                Complete</span>

                        </div> */}

                    </div>
                </div>
            </div>

            <div className='w-full relative content-hi'>
                <HotelInformationList hotelinfolist={data[tab]?.hotelInformation || []} hotelInfo={data[tab].hotelInformation[0]} />
            </div>
        </>
    )
}
